/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/DUCATI.glb 
*/
import React, { useRef, useState, useEffect } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { easing } from 'maath'
import { TextureLoader, MeshStandardMaterial, RepeatWrapping, MeshPhysicalMaterial, Color } from 'three';
import { cameraViewMatrix } from 'three/examples/jsm/nodes/Nodes.js';

export function Yacht_Upholstery_P({color5, ...props}) {
  const { nodes, materials } = useGLTF('/yacht-base.glb')
  const ref = useRef()

  const [currentColor, setCurrentColor] = useState(new Color(color5));

  const paint = new MeshStandardMaterial({
    color: currentColor,
    roughness: 1,
    metalness: 0.25,
  });

  useFrame((state, delta) => {
    const targetColor = new Color(color5);
    easing.dampC(currentColor, targetColor, 0.1, delta);
    setCurrentColor(currentColor.clone()); // Update state to trigger re-render
    if (ref.current) {
      ref.current.material.color.set(currentColor); // Update the material color directly
    }
  });

  return (
    <group {...props} dispose={null} scale={10}>
      <mesh castShadow receiveShadow ref={ref} geometry={nodes.primary_lining.geometry} material={paint} material-rougness={0}/>
    </group>
  )
}

useGLTF.preload('/DUCATI.glb')

